import NewsListItem from './NewsListItem';
export default NewsListItem;
